import React, { Fragment } from "react";

export default function NewCricBuddyPortfolioHeroSection() {
  return (
    <Fragment>
      <div className="cb-hero-section">
        <video className="cb-hero-video" autoPlay muted loop playsInline>
          <source src="/images/CB/HeroSectionBg.mp4" type="video/mp4" />
        </video>

        <div className="cb-hero-overlay"></div>

        <div className="cb-hero-content container">
          <div className="row justify-content-center text-center">
            <div className="col-12 col-lg-10 mx-auto">
              <h1 className="cb-hero-h1">
                Mobile App Development for Cricbuddy
              </h1>
              <h3 className="cb-hero-h3">
                Cricbuddy is the ultimate all-in-one platform for sports venue
                booking. With multiple sports available, it’s the go-to app for
                players to book slots instantly and for venue owners to manage
                their facilities with ease.
              </h3>
            </div>

            <div className="col-12 mt-4 d-flex justify-content-center flex-wrap gap-3">
              <a
                href="https://apps.apple.com/in/app/cricbuddy/id6480105922"
                rel="nofollow"
                target="_blank"
              >
                <img
                  src="/images/CB/AppStore.svg"
                  alt="App Store Link"
                  className="img-fluid store-btn"
                />
              </a>
              <a
                href="https://play.google.com/store/apps/details?id=com.sprigstack.cric_buddy"
                rel="nofollow"
                target="_blank"
              >
                <img
                  src="/images/CB/PlayStore.svg"
                  alt="Play Store Link"
                  className="img-fluid store-btn"
                />
              </a>
            </div>

            <div className="col-12 cb-hero-images d-flex justify-content-center align-items-center">
              <img
                src="/images/CB/HeroSectionImg1.png"
                alt="Hero 1"
                className="img-fluid hero-img hero-img-1 img-left-rotate"
              />
              <img
                src="/images/CB/HeroSectionImg2.png"
                alt="Hero 2"
                className="img-fluid hero-img hero-img-2 img-overlap"
              />
            </div>
          </div>
        </div>

        <div className="cb-hero-bottom-overlay"></div>
      </div>
    </Fragment>
  );
}
